// extracted by mini-css-extract-plugin
module.exports = {"instructions":"instructions-module--instructions--1YCze"};